import { apiPost } from './client';

export type HelpOutcome = 'answered' | 'out_of_scope' | 'insufficient_docs';

export interface HelpCitation {
  chunk_id: string;
  section_path: string;
  source: string;
  score: number;
}

/**
 * Every outcome returns this same key set, so the panel never has to branch on
 * outcome to know which fields exist. Pinned server-side by
 * tests/integration/test_help_contract.py.
 */
export interface HelpAnswer {
  outcome: HelpOutcome;
  answer: string | null;
  steps: string[];
  citations: HelpCitation[];
  deep_link: string | null;
  question_id: string | null;
  model: string | null;
  elapsed_ms: number;
}

export interface AskHelpRequest {
  question: string;
  /** Advisory only. The server recomputes every fact about the org itself. */
  route?: string | null;
}

export async function askHelp(body: AskHelpRequest): Promise<HelpAnswer> {
  return apiPost<HelpAnswer>('/help/ask', body);
}

export async function submitHelpFeedback(
  questionId: string,
  helpful: boolean
): Promise<void> {
  return apiPost('/help/feedback', { question_id: questionId, helpful });
}
